import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Form, Row, Typography } from 'antd';
import { FormattedMessage } from 'react-intl';

import PasswordFormFields from '@/components/_common/PasswordFormFields';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

const CredentialsForm = ({ onSubmit }) => (
  <Row>
    <Col span={24} md={24}>
      <Typography.Title level={5} style={{ marginBottom: '12px' }}>
        <FormattedMessage id="settings.account.accessData" />
      </Typography.Title>

      <Form layout="vertical" onFinish={onSubmit} style={{ padding: '8px 0' }}>
        <PasswordFormFields />

        <SpaceForButton>
          <Button block type="primary" htmlType="submit">
            <FormattedMessage id="settings.account.personalData.submit" />
          </Button>
        </SpaceForButton>
      </Form>
    </Col>
  </Row>
);

CredentialsForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default CredentialsForm;
